import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD8p36whMXqy9Ez81YY7Ei7Rb-KAR9SMGc",
  authDomain: "ethiofututuretutor.firebaseapp.com",
  projectId: "ethiofututuretutor",
  storageBucket: "ethiofututuretutor.firebasestorage.app",
  messagingSenderId: "290880837649",
  appId: "1:290880837649:web:0574e8bdf0ed75989eb9b0",
  measurementId: "G-5GDXGY8W5Y"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export services
export const auth = getAuth(app);
export const functions = getFunctions(app);
export const db = getFirestore(app);

// Export callable functions for easy use throughout the app
export const getPendingTeachers = httpsCallable(functions, 'getPendingTeachers');
export const updateTeacherStatus = httpsCallable(functions, 'updateTeacherStatus');